<template>
  <div class="fixed-sn">
    <div class="wrapper container">
      <header v-show="isLogin" style="">
        <nav class="navbar navbar-light white p-0 fixed-top" style=""><a href="" class="navbar-brand logo"><img
              src="./assets/img/logo1.png" alt="logo"></a>
          <div class="navbar-panel-box">
            <div class="navbar-panel d-flex justify-content-between">
              <div class="d-flex align-items-center nav-top"><i class="far fa-user mr-2"></i> {{ getUser.username }} <i
                  class="fas fa-briefcase ml-4 mr-2"></i> {{ getUser.roles[0] }} (Standard) <i class="far fa-money-bill-alt ml-4 mr-2"></i>
                ({{ getUser.wallet.type }}) <span style="margin-left: 0.2rem; margin-top: 1px;">{{ getUser.wallet.credit | formatNumber }}</span><i
                  class="far fa-clock ml-4"></i><span style="margin-left: 0.2rem;">
                  <div class="btn-group"><a href="" id="timezone-nav" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false" class="nav-link dropdown-toggle"><span class="ml-2">GMT+07:00</span></a>
                    <div class="dropdown-menu" style="height: 300px; overflow-y: scroll;">
                      <div><a id="timezone0" href="" class="dropdown-item"><span class="ml-2">GMT+13:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone1" href="" class="dropdown-item"><span class="ml-2">GMT+12:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone2" href="" class="dropdown-item"><span class="ml-2">GMT+11:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone3" href="" class="dropdown-item"><span class="ml-2">GMT+10:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone4" href="" class="dropdown-item"><span class="ml-2">GMT+09:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone5" href="" class="dropdown-item"><span class="ml-2">GMT+08:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone6" href="" class="dropdown-item"><span class="ml-2">GMT+07:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone7" href="" class="dropdown-item"><span class="ml-2">GMT+06:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone8" href="" class="dropdown-item"><span class="ml-2">GMT+05:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone9" href="" class="dropdown-item"><span class="ml-2">GMT+04:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone10" href="" class="dropdown-item"><span class="ml-2">GMT+03:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone11" href="" class="dropdown-item"><span class="ml-2">GMT+02:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone12" href="" class="dropdown-item"><span class="ml-2">GMT+01:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone13" href="" class="dropdown-item"><span class="ml-2">GMT+00:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone14" href="" class="dropdown-item"><span class="ml-2">GMT-01:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone15" href="" class="dropdown-item"><span class="ml-2">GMT-02:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone16" href="" class="dropdown-item"><span class="ml-2">GMT-03:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone17" href="" class="dropdown-item"><span class="ml-2">GMT-04:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone18" href="" class="dropdown-item"><span class="ml-2">GMT-05:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone19" href="" class="dropdown-item"><span class="ml-2">GMT-06:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone20" href="" class="dropdown-item"><span class="ml-2">GMT-07:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone21" href="" class="dropdown-item"><span class="ml-2">GMT-08:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone22" href="" class="dropdown-item"><span class="ml-2">GMT-09:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone23" href="" class="dropdown-item"><span class="ml-2">GMT-10:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone24" href="" class="dropdown-item"><span class="ml-2">GMT-11:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                      <div><a id="timezone25" href="" class="dropdown-item"><span class="ml-2">GMT-12:00</span></a>
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                </span></div>
              <div class="d-flex align-items-center nav-top-links">
                <div class="btn-group"><a href="" id="lang-nav" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false" class="nav-link dropdown-toggle"><img v-show="getLang === 'en-US'" src="./assets/img/flag/usa.png" alt=""
                      width="20" height="20"><img v-show="getLang === 'th-TH'" src="./assets/img/flag/thailand.png" alt=""
                      width="20" height="20"><span v-show="getLang == 'en-US'" class="ml-2">English</span><span v-show="getLang == 'th-TH'" class="ml-2">Thai</span></a>
                  <div class="dropdown-menu"><a @click="setLang('th-TH')" id="thai-menu" class="dropdown-item"><img
                        src="./assets/img/flag/thailand.png" alt="" width="20" height="20"><span
                        class="ml-2">Thai</span></a>
                    <div class="dropdown-divider"></div><a @click="setLang('en-US')" id="englist-menu" class="dropdown-item"><img
                        src="./assets/img/flag/usa.png" alt="" width="20" height="20"><span
                        class="ml-2">English</span></a>
                    <div class="dropdown-divider"></div>
                  </div>
                </div><a target="_blank" href="https://youtu.be/ciUOA283zfE" class="nav-link"><i
                    class="fas fa-guide"></i> Guide </a><router-link to="/login" id="logout" class="nav-link"><i
                    class="fas fa-sign-out-alt"></i> Logout </router-link>
              </div>
            </div>
            <div class="promo-panel d-flex justify-content-between">
              <div class="promo-text" style="color: rgb(0, 0, 0) !important;">
                <p></p>
              </div>
            </div>
          </div>
        </nav>
        <div id="slide-out"
          class="side-nav white fixed wide side-nav-light z-depth-0 d-flex flex-column justify-content-between"
          style="">
          <Navbar :UsersInfo="getUser" ></Navbar>
          <div class="black-text p-2" style="margin-bottom: -35px;">version: 1.7.2</div>
        </div>
      </header>
      <router-view />
      <div id="modal-main" role="dialog" tabindex="-1" aria-hidden="true" class="modal fade"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters,mapMutations } from 'vuex'
import Navbar from "./components/Navbar.vue";

export default {
  name: "App",
  //mixins: [CheckSession],
  data() {
    return {
      isLogin: false,
    };
  },
  computed: {
    ...mapGetters(["getUser", "getLang"]),
  },
  components: {
    Navbar
  },
  mounted() {
    this.CheckSessions();
  },
  beforeMount() {
    this.CheckSessions();
  },
  beforeDestroy() {
    this.CheckSessions();
  },
  beforeUpdate() {
    this.CheckSessions();
  },
  created() {
    this.CheckSessions();
  },
  methods: {
    ...mapMutations(["setLang"]),
    CheckSessions() {
      if (
        this.$router.history.current.name == "Login" ||
        this.$router.history.current.name == 'history-game' ||
        this.$router.history.current.name == "Signup"
      ) {
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
  },
};
</script>
<style scoped>
@import './assets/css/mdb.css';
@import './assets/css/style.css';
</style>
